var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6328 20.5C17.3272 20.5 21.1328 16.6944 21.1328 12C21.1328 7.30558 17.3272 3.5 12.6328 3.5C7.93839 3.5 4.13281 7.30558 4.13281 12C4.13281 16.6944 7.93839 20.5 12.6328 20.5ZM12.6328 22C18.1557 22 22.6328 17.5228 22.6328 12C22.6328 6.47715 18.1557 2 12.6328 2C7.10996 2 2.63281 6.47715 2.63281 12C2.63281 17.5228 7.10996 22 12.6328 22Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74679 16.6871C8.12635 16.8529 8.56849 16.6797 8.73433 16.3001C9.39084 14.7975 10.8894 13.7498 12.631 13.7498C14.3726 13.7498 15.8712 14.7975 16.5277 16.3001C16.6936 16.6797 17.1357 16.8529 17.5153 16.6871C17.8948 16.5212 18.0681 16.0791 17.9022 15.6995C17.0156 13.6703 14.9901 12.2498 12.631 12.2498C10.272 12.2498 8.2464 13.6703 7.3598 15.6995C7.19396 16.0791 7.36722 16.5212 7.74679 16.6871Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63281 9C9.63281 9.55228 9.1851 10 8.63281 10C8.08053 10 7.63281 9.55228 7.63281 9C7.63281 8.44772 8.08053 8 8.63281 8C9.1851 8 9.63281 8.44772 9.63281 9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6328 9C17.6328 9.55228 17.1851 10 16.6328 10C16.0805 10 15.6328 9.55228 15.6328 9C15.6328 8.44772 16.0805 8 16.6328 8C17.1851 8 17.6328 8.44772 17.6328 9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.6099451a3b1a7093b4a04ddccd9a7eef.svg";
export { ForwardRef as ReactComponent };